import { Component, Input, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatCalendar, MatDatepickerModule } from '@angular/material/datepicker';
import { SERVICE_BOOKING_API, ServiceBookingApi } from '@app/_services/service-booking-api';
import * as _ from 'lodash';
import * as moment from 'moment';
import { CustomTimeRangeComponent } from './componenets/custom-timeRange/custom-timeRange.component';
import { TimeslotViewComponent } from './componenets/timeslot-view/timeslot-view.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-single-date-inlinePicker',
    templateUrl: './single-date-inlinePicker.component.html',
    styleUrls: ['./single-date-inlinePicker.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        MatDatepickerModule,
        TimeslotViewComponent,
        CustomTimeRangeComponent,
    ],
})
export class SingleDateInlinePickerComponent implements OnInit, AfterViewInit {
    constructor(private fb: UntypedFormBuilder, @Inject(SERVICE_BOOKING_API) private bookingApi: ServiceBookingApi) { }

    //service item data
    @Input() product;
    @Input() disabledDates: string[];
    @Input() timeslots: any;
    @Input() timeType;
    @Input() form;

    availableFrom: Date;
    availableTo: Date;
    selectedDate: Date;
    currentYearMonth: Date;
    fetched: string[] = [];
    timeFrom: Date;
    timeTo: Date;

    @Input() date = this.fb.control([''])

    onSelect(event) {
        this.date.setValue(new Date(event));
        this.selectedDate = new Date(event);
        this.setTimeConstrainst()
    }

    setTimeConstrainst() {
        let weekDay = (this.date.value as Date).getDay()

        let setting = this.product?.serviceSettings?.find((element)=>{return element.day == weekDay});

        this.timeFrom = new Date(setting?.range?.start) || moment().toDate();
        this.timeTo = new Date(setting?.range?.end) || moment().toDate();

        this.availableFrom = new Date(setting?.range?.start);
        this.availableTo = new Date(setting?.range?.end);


    }

    weekday = [];
    initialized = false;
    today = new Date();
    maxDate = new Date( Date.now() + (3 * 30 * 24 * 60 * 60 * 1000) );

    ngOnInit(): void {
        this.maxDate = moment().add(6, 'months').toDate();
        this.initialized = true;
    }

    @ViewChild('calendar', { static: false }) calendar: MatCalendar<Date>;

    isSameMonthYear(dateA: Date, dateB: Date) {
        return dateA.getFullYear() == dateB.getFullYear() && dateA.getMonth() == dateB.getMonth();
    }

    getYearMonth(date: Date) {
        return `${date.getFullYear()}-${date.getMonth() + 1}`;
    }

    getFullDate(date: Date) {
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${(date.getDate()).toString().padStart(2, '0')}`;
    }

    ngAfterViewInit() {
        this.disabledDates = this.disabledDates || [];
        this.currentYearMonth = new Date();
        this.calendar?.stateChanges?.subscribe((res) => {
            let activeDate = this.calendar.activeDate;
            if (this.fetched.includes(this.getYearMonth(activeDate))) return;
            if (!this.isSameMonthYear(activeDate, this.currentYearMonth)) {
                this.currentYearMonth = activeDate;
                let date = moment(activeDate);
                this.bookingApi.getDisabledDates(this.product._id, date.startOf('month').toISOString(), date.endOf('month').toISOString()).subscribe(
                    (result) => {
                        if (result.code == 200) {
                            this.disabledDates = this.disabledDates.concat(result.data);
                        }
                        this.fetched.push(this.getYearMonth(activeDate));
                        this.dateFilter = this.dateFilterFunction();
                    }
                );
            }
        });
        this.fetched.push(this.getYearMonth(new Date()));
        this.dateFilter = this.dateFilterFunction();
    }

    dateFilterFunction() {
        return (date: Date) => {
            if (!this.fetched.includes(this.getYearMonth(date))) return false;
            if (_.isEmpty(this.disabledDates)) return true;
            return !this.disabledDates.includes(this.getFullDate(date));
        };
    }

    //filter out non-work days and or booked days
    dateFilter = this.dateFilterFunction();
}
